// This init routine fixes an issue where logged out user with wt_plus=1 cookie
// will never see an ad until the have logged in or logged out again.
//
// Note that we are using wt_plus cookie to determine the proper wallpaper provider in ad-sdk.
// https://github.com/WeTransfer/frontend/pull/12578
import Helper from '@wetransfer/transfer/helper';
import userActions from '@wetransfer/transfer/store/action/user';

export const init = ({ cookieDomain, userLoggedIn }) => {
  // If the user is NOT logged in and still has 1 as wt_plus value,
  // the cookie should be removed.
  if (!userLoggedIn && Helper.getWTPlus() === 1) {
    userActions.unsetWTPlusCookie({ domain: cookieDomain });
  }
};

export default init;
